import { Logo } from "@p0security/frontend-core/react";
import { integrationRegistry } from "@p0security/shared/integrations/registry";
import { mapValues } from "lodash-es";
import type React from "react";

// A package-local copy of `frontend/src/components/Integrations/
// IntegrationLogo.tsx`, needed for field `labeler`/`optionProvider`
// callbacks that the `Install.tsx` siblings mechanism doesn't reach.
const INCIDENT_IO_ICON_URL = "https://incident.io/favicon.ico";
const PAGERDUTY_ICON_URL = "https://pagerduty.com/favicon.ico";

/** Annotated rather than inferred: the inferred type is keyed on the
 * registry's literal keys, so a lookup by a runtime-derived key needs a cast.
 */
export const AllIntegrationLogos: Record<string, React.ReactNode> = {
  ...mapValues(integrationRegistry, ({ logoUrl, label }) => (
    <Logo logo={logoUrl} title={label} />
  )),
  pagerduty: <Logo logo={PAGERDUTY_ICON_URL} title="PagerDuty" />,
  incidentio: <Logo logo={INCIDENT_IO_ICON_URL} title="Incident.io" />,
};
